import React, { useState, useEffect } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import { apiClient } from '../api';


const LoginPage = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // ADD THIS USEEFFECT FOR DEBUGGING
  useEffect(() => {
    console.log('LoginPage mounted, current path:', window.location.pathname);
    console.log('onLoginSuccess prop:', onLoginSuccess);
  }, [onLoginSuccess]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // 1. Authentication - Get JWT Tokens using apiClient
      const { data } = await apiClient.login({
        email: email.trim().toLowerCase(),
        password
      });

      // 2. Store tokens
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);

      // 3. Fetch user data with the new token
      const userResponse = await apiClient.getCurrentUser();
      const userData = userResponse.data;

      // DEBUG: Check the actual response structure
      console.log('Full API response:', userResponse);
      console.log('Response data:', userData);
      console.log('User object:', userData.user);
      console.log('is_delivery_agent:', userData.user?.is_delivery_agent);
      
      // 4. CHECK IF USER IS A DELIVERY AGENT - FIXED LOGIC
      if (userData.user && userData.user.is_delivery_agent) {
        console.log('User is delivery agent - redirecting to React dashboard');
        
        // OPTION 1: Navigate to React dashboard component (RECOMMENDED)
        navigate('/delivery-dashboard');

        setTimeout(() => {
    console.log('After navigation - current path:', window.location.pathname);
  }, 100);
        
        // OPTION 2: Or fetch dashboard data and render it
        // await fetchDeliveryDashboardData();
        
      } else {
        console.log('✗ User is not delivery agent - is_delivery_agent value:', userData.user?.is_delivery_agent);
        navigate('/');
      }

      // 5. Call success callback if provided
      if (onLoginSuccess) {
        onLoginSuccess({
          user: userData,
          token: {
            access: data.access,
            refresh: data.refresh
          }
        });
      }

    } catch (err) {
      console.error('Login error:', err);
      setError(
        err.response?.data?.detail || 
        err.response?.data?.non_field_errors?.join(', ') || 
        'Invalid email or password'
      );
    } finally {
      setIsLoading(false);
    }
  };

return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-2">Login</h2>
      
      {error && (
        <div className="text-red-500 text-sm mb-4">{error}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border rounded"
            required
          />
        </div>
        
        <div className="space-y-2">
          {/* PASSWORD LABEL AND FORGOT PASSWORD LINK ON SAME LINE */}
          <div className="flex justify-between items-center">
            <label className="block text-sm font-medium">Password</label>
            
            {/* CHANGED TO LINK COMPONENT */}
            <Link 
              to="/password-reset" 
              className="text-blue-500 hover:underline text-sm"
            >
              Forgot password?
            </Link>
          </div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 border rounded"
            required
          />
        </div>
        
        {/* LOGIN BUTTON - FULL WIDTH */}
        <div className="pt-4">
          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-2 px-4 bg-black text-white rounded hover:bg-gray-800"
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </form>

    </div>
  );
};
export default LoginPage;